import { request } from '@/utils/request';

// 获取合同类型列表
export const getContractTypeList = params => {
  return request('/zlb/api/expense/contract/type/config/list', { method: 'GET', params });
};

// 获取合同类型全部
export const getContractTypeListAll = params => {
  return request('/zlb/api/expense/contract/type/config/listAll', { method: 'GET', params });
};

// 新增类型
export const addContractType = params => {
  return request('/zlb/api/expense/contract/type/config/save', { method: 'POST', data: params });
};

// 编辑类型
export const updateContractType = params => {
  return request('/zlb/api/expense/contract/type/config/save', { method: 'POST', data: params });
};

// 删除类型
export const deleteContractType = data => {
  return request(`/zlb/api/expense/contract/type/config/${data.contractTypeCode}`, {
    method: 'DELETE',
    data,
  });
};

// 保存合同规则配置
export const configContractRule = parmas => {
  return request('/zlb/api/expense/contract/rule/config/save', { method: 'POST', data: parmas });
};

// 获取合同规则配置
export const getContractRuleConfig = data => {
  return request('/zlb/api/expense/contract/rule/config/detail', { method: 'GET', data });
};
